// extracted by mini-css-extract-plugin
module.exports = {"rotate":"styles_rotate__V_XR9","rotation":"styles_rotation__2GvxZ"};